"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("./sis-information-box.component.css");
var InformationBoxComponent = /** @class */ (function () {
    function InformationBoxComponent() {
        this.width = 320;
        this.color = "light";
        this.position = "isRight";
        this.isVisible = false;
        this.calculateInformationBoxCoordinates();
        window.addEventListener("resize", this.calculateInformationBoxCoordinates);
    }
    InformationBoxComponent.prototype.ngOnInit = function () {
        if (!this.width || isNaN(this.width)) {
            this.width = this.getDynamicWidth();
        }
    };
    InformationBoxComponent.prototype.getDynamicWidth = function () {
        var contentSize = this.message.length;
        var width;
        if (contentSize <= 100) {
            width = 240;
        }
        else if (contentSize > 100 && contentSize <= 500) {
            width = 360;
        }
        else if (contentSize > 500 && contentSize <= 1500) {
            width = 480;
        }
        else if (contentSize > 1500 && contentSize <= 2500) {
            width = 600;
        }
        else {
            width = 720;
        }
        return width;
    };
    InformationBoxComponent.prototype.onMouseEntered = function (event) {
        this.isVisible = true;
    };
    InformationBoxComponent.prototype.onMouseLeaved = function () {
        this.isVisible = false;
    };
    InformationBoxComponent.prototype.calculateInformationBoxCoordinates = function () {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        //SisInformationBoxComponent width and max-height
        //320 x 400
        //console.log(this.windowWidth, this.windowHeight);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], InformationBoxComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], InformationBoxComponent.prototype, "iconId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], InformationBoxComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], InformationBoxComponent.prototype, "message", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], InformationBoxComponent.prototype, "width", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], InformationBoxComponent.prototype, "color", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], InformationBoxComponent.prototype, "position", void 0);
    __decorate([
        core_1.ViewChild('messageBox'),
        __metadata("design:type", core_1.ElementRef)
    ], InformationBoxComponent.prototype, "messageBox", void 0);
    InformationBoxComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-information-box',
            template: require('./sis-information-box.component.html'),
        }),
        __metadata("design:paramtypes", [])
    ], InformationBoxComponent);
    return InformationBoxComponent;
}());
exports.InformationBoxComponent = InformationBoxComponent;
//# sourceMappingURL=sis-information-box.component.js.map